import React from 'react'
import { Button, Modal } from 'react-bootstrap'

export default function DiscountApplyTo({ show, handleClose, codeData }) {
    if (!codeData) return;
    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Apply To</Modal.Title>
            </Modal.Header>
            <Modal.Footer>
                <div className='row w-100'>
                    <div className='col-md-12'>
                        <h4>Client List</h4>
                        <p style={{ border: '1px solid black', padding: '10px 5px', borderRadius: '5px' }}>
                            {(codeData?.users_name ?? []).map((item, index) => (
                                <span key={index}>{item?.name + " " + item?.lastname}, </span>
                            ))}
                            {(codeData?.users_name?.length === 0 || !codeData?.users_name) && (
                                <span style={{ paddingLeft: '43%', fontWeight: '600' }}>All Uses</span>
                            )}
                        </p>
                    </div>
                </div>
                <div className='row w-100'>
                    <div className='col-md-12'>
                        <h4>Pass List</h4>
                        <p style={{ border: '1px solid black', padding: '10px 5px', borderRadius: '5px' }}>
                            {(codeData?.pass_name ?? []).map((item, index) => (
                                <span key={index}>{item?.pass_name}, </span>
                            ))}
                            {(codeData?.pass_name?.length === 0 || !codeData?.pass_name) && (
                                <span style={{ paddingLeft: '43%' }}>No Record Found</span>
                            )}
                        </p>
                    </div>
                </div>

                <div className='row w-100'>
                    <div className='col-md-12'>
                        <h4>Product List</h4>
                        <p style={{ border: '1px solid black', padding: '10px 5px', borderRadius: '5px' }}>
                            {(codeData?.products_name ?? []).map((item, index) => (
                                <span key={index}>{item?.product_name}, </span>
                            ))}
                            {(codeData?.products_name?.length === 0 || !codeData?.products_name) && (
                                <span style={{ paddingLeft: '43%' }}>No Record Found</span>
                            )}
                        </p>
                    </div>
                </div>

                <div className='row w-100'>
                    <div className='col-md-12'>
                        <h4>Workshop List</h4>
                        <p style={{ border: '1px solid black', padding: '10px 5px', borderRadius: '5px' }}>
                            {(codeData?.workshop_names ?? []).map((item, index) => (
                                <span key={index}>{item?.name}, </span>
                            ))}
                            {(codeData?.workshop_names?.length === 0 || !codeData?.workshop_names) && (
                                <span style={{ paddingLeft: '43%' }}>No Record Found</span>
                            )}
                        </p>
                    </div>
                </div>

                <div className='row w-100'>
                    <div className='col-md-12'>
                        <h4>Service List</h4>
                        <p style={{ border: '1px solid black', padding: '10px 5px', borderRadius: '5px' }}>
                            {(codeData?.service_names ?? []).map((item, index) => (
                                <span key={index}>{item?.service_name}, </span>
                            ))}
                            {(codeData?.service_names?.length === 0 || !codeData?.service_names) && (
                                <span style={{ paddingLeft: '43%' }}>No Record Found</span>
                            )}
                        </p>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    )
}
